module.exports = __webpack_public_path__ + "logo3.png";